import { Avatar, Tag, Typography } from "@/components/ui/atoms";
import type { BlogAuthor, BlogTag } from "../../types";
import { formatLongDate } from "@/utils/date";

interface MetaBarProps {
  publishedAt?: string;
  createdAt?: string;
  tags?: BlogTag[];
  author?: BlogAuthor;
}

export function MetaBar({ publishedAt, createdAt, tags = [], author }: MetaBarProps) {
  return (
    <div className="flex flex-col gap-4 border-y border-dark-invirtus-soft py-4 md:flex-row md:items-center md:justify-between">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
        {author?.name ? (
          <div className="flex items-center gap-2 border-r border-dark-invirtus-soft pr-6">
            <Avatar
              initials={author.name}
              src={author.avatarUrl}
              alt={author.name}
              size="sm"
              variant={author.avatarUrl ? "neutral" : "gradient"}
            />
            <Typography as="span" variant="body-lg" weight="semibold" color="primary">
              {author.name}
            </Typography>
          </div>
        ) : null}
        <Typography as="p" variant="body-sm" color="secondary" weight="medium">
          {formatLongDate(publishedAt || createdAt)}
        </Typography>
      </div>
      {tags.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => (
            <Tag key={`${tag.id}-${tag.name}`} variant="subtle" intent="primary" palette="brand">
              {tag.name}
            </Tag>
          ))}
        </div>
      ) : null}
    </div>
  );
}
